import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "~/components/ui/LoadingSpinner";
import { useBranch } from "~/contexts/BranchContext";
import { useShoppingCart } from "~/contexts/ShoppingCartContext";
import ModernCategoryPage from "~/templates/modern/menu/ModernCategoryPage";
import type { MenuItem } from "~/types/new_types";
import NotFoundPage from "../not-found/NotFoundPage";
import { useViewMode } from "~/contexts/ViewModeContext";

const CategoryPage = () => {
  const { t } = useTranslation();

  const { viewMode, setViewMode } = useViewMode();
  const [SubcategoryStyle, setSubcategoryStyle] = useState<
    "tabs" | "dropdown"
  >("tabs");
  const { tempQuantities } = useShoppingCart();
  const totalCartItems = Object.values(tempQuantities).filter(
    (item) => item.quantity > 0
  ).length;
  const {
    branchData,
    categories,
    isLoading,
    error,
    activeCategory,
    menuItems,
    setSelectedItem,
    isAgentActive,
  } = useBranch();

  useEffect(() => {
    if (branchData?.branch.theme) {
      // Keep category style synced to theme; view mode is global now
      setSubcategoryStyle(branchData?.branch.theme.SubcategoryStyle as "tabs" | "dropdown");
    }
  }, [branchData]);

  const handleChatbotItemClick = (item: MenuItem) => {
    setSelectedItem(item);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size={4} message={t("restaurant.loading")} />
      </div>
    );
  }

  if (error || !branchData) {
    return <NotFoundPage />;
  }

  return (
    <>
      {/* <ChatbotProvider useMockApi={false}> */}
      <ModernCategoryPage
        SubcategoryStyle={SubcategoryStyle}
        setSubcategoryStyle={setSubcategoryStyle}
        setViewMode={(v) => setViewMode(typeof v === 'function' ? v(viewMode) : v)}
        viewMode={viewMode}
      />

    </>
  );
};
export default CategoryPage;
